import { render, staticRenderFns } from "./SummarySettlementKasbon.vue?vue&type=template&id=318d339e"
import script from "./SummarySettlementKasbon.vue?vue&type=script&lang=js"
export * from "./SummarySettlementKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports